import baustein from "baustein";
import globals from "web/script/modules/globals";
import template from "templates/modules/scroll_to_top_btn.jinja";
import analytics from "web/script/analytics/analytics";
import browser from "web/script/utils/browser";

const SHOW_MODIFIER = "scroll-to-top-button--show";

export default baustein.register("scroll-to-top-button", {
    tagName: "button",

    // NOTE: scroll-to-top-button will only render itself using 'template'
    // when it's created by another JavaScript component.
    // E.g. in media/web/script/components/product-feed.js

    // If you wish to include a scroll-to-top-button
    // in a server-rendered template
    // use {% include "modules/scroll_to_top_btn.jinja" %}

    template,

    setupEvents(add) {
        add("click", this.scrollToTop);
    },

    onInsert() {
        this.setGlobalHandler("scroll", this.onScroll);
    },

    onRemove() {
        this.releaseGlobalHandler("scroll", this.onScroll);
    },

    scrollToTop(event) {
        event.preventDefault();

        this.emit("scroll-to-top-start");
        this.el.classList.remove(SHOW_MODIFIER);

        analytics.event("NAVIGATION", "SCROLL_TO_TOP", "button");

        browser.scrollTop(0).then(() => {
            this.emit("scroll-to-top-end");
        });
    },

    onScroll() {
        this.updateAfterScroll(globals.window.pageYOffset, browser.getWindowHeight());
    },

    updateAfterScroll(pageYOffset, windowHeight) {
        let shouldShow = pageYOffset > windowHeight * 1.5;

        if (shouldShow) {
            this.el.classList.add(SHOW_MODIFIER);
        } else {
            this.el.classList.remove(SHOW_MODIFIER);
        }
    },
});
